import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Splide from '@splidejs/splide';
import { QuickPanelService } from "app/layout/components/quick-panel/quick-panel.service";
import { lang_notificaciones } from "app/idiomas/i18n/notificaciones/notificaciones.lang";
import { HomeV2Service } from "./home-v2.service";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
@Component({
  selector: 'home-v2',
  templateUrl: './home-v2.component.html',
  styleUrls: ['./home-v2.component.scss']
})


export class HomeV2Component implements OnInit {
  cargando=false;
  jsonCustomHome:any;


  cardsCatego = [];
  historyEventCompany=[];
  infoEmpresa: any;
  infoUsuario = JSON.parse(localStorage.getItem('userData'));
  accionTextSecLangua=["languageNative","sinAdicionales","languageAdittional","conAdicionales","deleteLangNative","completePasLang"];
  accionTextSecTemplate=["completePasTemplate"];
  accionTextSecSurvey=["createSurvey","saveUserDemo","recreateSurvey","saveSeccionNps","saveSeccionReactivos","saveSeccionControl","saveSeccionDemogra","saveSeccionAbier","saveSeccionForall","saveSeccionAdicio","saveUsersSurvey","completePasEncues","DescompletePasEncues"];
  accionTextSecColab=["subBaseColab","downloadBaseColab","deleteBaseColab","completePasColab","DescompletePasColab","saveUsersSurvey"];
  accionTextSecPrograSurvey=["regisFechaLanza","regisFechaAviso1","regisFechaAviso2","saveRecordatorioEncu","completePasProgra","DescompletePasProgra"];
  accionTextSecSendEmail=["enviarCorreos","noEnviarCorreos","cambiarEstatusCorreo","completePasEnvi","DescompletePasEnvi"];
  accionTextSecActiSurve=["ActivaEstatEncu","DesacEstatEncu","completePasEstat","DescompletePasEstat"];
  idiomaActual:string;
  instituto:any;
  infoCargada=false;
  constructor(
    private router: Router,
    private _fuseSidebarService: FuseSidebarService,
    private qps: QuickPanelService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private homeService: HomeV2Service,
    private translateSrv: TranslateService,
  ) {
    lang_notificaciones.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => {
      this.idiomaActual = this.translateSrv.currentLang;
      this.cargando=false;
      this.infoCargada=false;
      this.cardsCatego = [];
      this.getEmpresa();
      this.getHistorial();
    });
    this.idiomaActual = this.translateSrv.currentLang;
  }

  ngOnInit(): void {
    this._fuseSidebarService.getSidebar('navbar').fold();
    this.getEmpresa();
    this.getHistorial();
    console.log("infoUsuario",this.infoUsuario);
      }

  async getEmpresa(){
    const resultado: any = await this.homeService.getEmpresa(localStorage.getItem('companyID')).toPromise().then((respuesta:any) => { return respuesta; });
    if(resultado.message == 'Success'){
      this.infoEmpresa = resultado.data;
      localStorage.setItem('instituto', resultado.data.institutoEmpresa);
      localStorage.setItem('institutoRquerimientos', resultado.data.institutoEmpresa);
      this.instituto=resultado.data.institutoEmpresa;
      this.getJsonConfiguration(resultado.data.institutoEmpresa);
    }
    // console.log("getEmpresa:",resultado);

  }

  async getJsonConfiguration(instituto){
    const resultado: any = await this.homeService.getJsonConfiguration(instituto).toPromise().then((respuesta:any) => { return respuesta; });
    if(resultado.success == true){
      this.jsonCustomHome = resultado.json_home;
      this.getActiveProductsHome();
    }
    console.log("jsonCustomHome:",this.jsonCustomHome);

  }

  async getActiveProductsHome(){
    const resultado: any = await this.homeService.getActiveProductsHome(localStorage.getItem('companyID')).toPromise().then((respuesta:any) => { return respuesta; });
    if(resultado.success==true){
      switch (this.infoUsuario.level) {
        case 4: //Usuario nivelResultados
        if(resultado.active_results!=undefined && resultado.active_results.length>0) {
            let tipoProducto:any;
            switch(resultado.active_results[0].idProducto) {
              case 20: case 40: case 56: case 57: case 58: tipoProducto="certificar";break;
              case 41:tipoProducto="medir";break;
              case 42:tipoProducto="pulsecheck";break;
              default:
                break;
            }
            localStorage.setItem('productoID', resultado.active_results[0].idCertificar);
            localStorage.setItem('tipoMedir',resultado.active_results[0].idProducto);
            localStorage.setItem('fechaProductorResult',resultado.active_results[0].fechaCertificar);
            let ruta='/results/trust_index/'+tipoProducto;
            this.router.navigate([ruta]);
        }else{
            let rutaHome='/home';
            this.router.navigate([rutaHome]);
        }

          break;
          case 1: //Usuario nivel empresa
          if (resultado.active_results!=undefined && resultado.active_results.length>0) {
            let cardsCon=[];
            resultado.active_results.forEach((product,i) => {
              let indexProduct= resultado.active_results.findIndex(item=>item.idProducto== product.idProducto);
              let prod={
                idProducto:product.idProducto,
                data:indexProduct!=-1 ? resultado.active_results[i]:null,
              }
              cardsCon.push(prod)
            });
            this.cardsCatego.push({clave:'cat_result_activ',cardsConten:cardsCon});
          }

          if (resultado.active_products!=undefined && resultado.active_products.length>0) {
            let cardsCon=[];
            let cardsConResult=[];
            resultado.active_products.forEach((product,i) => {
              let indexProduct= resultado.active_products.findIndex(item=>item.idProducto== product.idProducto);
              let indexProductCulture= resultado.active_products.findIndex(item=>item.tipo== product.tipo);
              let prod:any;
              console.log("indexProduct",indexProduct);
              prod={
                idProducto:product!.idProducto? product!.idProducto:'culture',
                data:indexProduct!=-1 ? resultado.active_products[i]:null,
              }
              cardsCon.push(prod)
            });
            this.cardsCatego.push({clave:'cat_product_activ',cardsConten:cardsCon});
          }
          this.infoCargada=true;
          break;
          case 19: //Usuario nivelResultados 2.0
          if(resultado.active_results!=undefined && resultado.active_results.length>0) {
              let tipoProducto:any;
              switch(resultado.active_results[0].idProducto) {
                case 20: case 40: case 56: case 57: case 58: tipoProducto="certificar";break;
                case 41:tipoProducto="medir";break;
                case 42:tipoProducto="pulse-check";break;
                default:
                  break;
              }
              localStorage.setItem('productoID', resultado.active_results[0].idCertificar);
              localStorage.setItem('tipoMedir',resultado.active_results[0].idProducto);
              localStorage.setItem('fechaProductorResult',resultado.active_results[0].fechaCertificar);
              let ruta='/results/trust_index/'+tipoProducto;
              this.router.navigate([ruta]);
          }else{
              let rutaHome='/home';
              this.router.navigate([rutaHome]);
          }

            break;
        default:
          break;
      }


  }
    this.cargando=true;
    console.log("getActiveProductsHome:",resultado);
    console.log("cardsCatego:",this.cardsCatego);
  }

  async getHistorial(){
    const resultado: any = await this.qps.getNotificacionesEmpresaID(localStorage.getItem('companyID')).toPromise().then((respuesta:any) => { return respuesta });
    if(resultado.message == 'success'){
      // console.log("HISTORIAL:",resultado);

      let arregloHistorial: any = [];
      resultado.historial.forEach(producto => {
        const historialMod = producto.historial.map(evento => { const infoProd = {producto: JSON.parse(JSON.stringify(producto))}; delete infoProd.producto.historial; return {...evento, ...infoProd} })
        arregloHistorial = [...arregloHistorial, ...historialMod];
      });
      arregloHistorial.sort((a,b) => { return (a.createdAt > b.createdAt) ? -1 : ((a.createdAt < b.createdAt) ? 1 : 0); });
      // console.log("arregloHistorial:",arregloHistorial);
      arregloHistorial.forEach(evento => {
        if(evento.accionText != undefined && evento.accionText != 'LogOut'){
          this.historyEventCompany.push({
            icon: this.accionTextSecLangua.includes(evento.accionText)? 'language':(this.accionTextSecTemplate.includes(evento.accionText) ? 'wysiwyg':(this.accionTextSecSurvey.includes(evento.accionText) ? 'list_alt':(this.accionTextSecColab.includes(evento.accionText) ? 'people':(this.accionTextSecPrograSurvey.includes(evento.accionText) ? 'date_range': (this.accionTextSecSendEmail.includes(evento.accionText) ? 'send': (this.accionTextSecActiSurve.includes(evento.accionText) ? 'build_circle':'note')))))),
            product: evento.producto.tipoProducto,
            desription: evento.accionText,
            date: evento.createdAt,
            dateProduct:evento.producto.fechaProducto,
          });
        }
      });

      // console.log(this.historyEventCompany);

    }
  }
}
